import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';   
const Discipline = () => {  
  useEffect(() => {
    document.title = 'Discipline - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>Prospectus</li>
                    <li>Discipline</li>
                </ul>
            </div> 
            <section className="innerbody">
            <div className="container"> 
                    <div className="row">
                    <div className="col-lg-12">
                         <p>Co-operation of parents/guardians is most essential for maintaining discipline in all
                         the school programmes and school life. Too much leniency may spoil the child, but freedom within limits without
                         suppressing and interfering in the development of the child's personality is the goal of the institution.</p>
                    </div>
                    </div> 
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default Discipline;
